"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = NotifyIcon;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _icons = _interopRequireDefault(require("./attrs/icons"));
var _excluded = ["fontSize", "color", "iconName", "style", "viewBox", "sx"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function NotifyIcon(props) {
  var fontSize = props.fontSize,
    color = props.color,
    iconName = props.iconName,
    style = props.style,
    viewBox = props.viewBox,
    sx = props.sx,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_material.SvgIcon, _extends({
    fontSize: fontSize,
    color: color,
    style: style,
    viewBox: viewBox,
    sx: sx
  }, rest), _icons["default"][iconName]);
}
NotifyIcon.propTypes = {
  iconName: _propTypes["default"].string.isRequired,
  fontSize: _propTypes["default"].string,
  color: _propTypes["default"].string,
  style: _propTypes["default"].shape({}),
  viewBox: _propTypes["default"].string,
  sx: _propTypes["default"].shape({})
};
NotifyIcon.defaultProps = {
  fontSize: 'default',
  color: 'inherit',
  style: {},
  viewBox: '0 0 24 24',
  sx: {}
};